import React from 'react';
import './Filter.scss';
import {connect} from 'react-redux';
import {
    setFilter,
    setScreen,
    setSpecialFeatureConsent,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setConsent,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
} from '../../../../../redux/actions';
import Switch, {SwitchColor} from "../../../../Switch/Switch";
import {allInterests, allPurposes} from "../../../../../scripts/lib/handlers";

const Filter = props => {

    const defaultSwitchOnClickHandler = (config) => {
        props.setFilter({filterName: config.filterName, value: config.object});
        props.setScreen(3);
    }

    const specialFeatureSwitchOnChangeHandler = (specialFeatureId) => {
        let {specialFeatureOptins} = props.configuration;

        if (typeof props.configuration.static?.specialFeatureOptins?.[specialFeatureId] !== 'boolean') {
            specialFeatureOptins[specialFeatureId] = !specialFeatureOptins[specialFeatureId];
            props.setSpecialFeatureConsent(specialFeatureOptins);
        }
    }

    const purposeConsentSwitchOnChangeHandler = (purposeConsentId, filterName) => {
        let {purposeConsent, vendorConsent} = props.configuration;

        if (typeof props.configuration.static?.purposeConsent?.[purposeConsentId] !== 'boolean') {
            purposeConsent[purposeConsentId] = !purposeConsent[purposeConsentId];
            props.setPurposeConsent(purposeConsent);
            changeVendorConsent(
                {type: filterName, id: purposeConsentId},
                purposeConsent,
                vendorConsent,
                props.setConsent,
                props.setAllConsentSwitch
            );
            props.setAllConsentSwitch(allPurposes(props.configuration));
        }
    }

    const purposeLegitimateInterestSwitchOnChangeHandler = (purposeLegIntId, filterName) => {
        let {purposeLegitimateInterest: purposeLegInt, objectConsent} = props.configuration;

        if (typeof props.configuration.static?.purposeLegitimateInterest?.[purposeLegIntId] !== 'boolean') {
            purposeLegInt[purposeLegIntId] = !purposeLegInt[purposeLegIntId];
            props.setPurposeLegitimateInterest(purposeLegInt);
            changeVendorConsent(
                {type: filterName, id: purposeLegIntId},
                purposeLegInt,
                objectConsent,
                props.setObjectConsent,
                props.setAllObjectConsentSwitch
            );
            props.setAllObjectConsentSwitch(allInterests(props.configuration));
        }
    }

    const changeVendorConsent = (filter, switchStates, vendorConsent, setVendorConsent, setAllVendorConsent) => {
        const vendorsOfFilter = props.configuration.vendorList.vendors.filter(vendor => vendor[filter.type].includes(filter.id));

        vendorsOfFilter.forEach(vendor => {
            // Other switches are considered ON when the current switch is OFF
            const otherSwitchesOn = !switchStates[filter.id] && vendor[filter.type].some(filterId => switchStates[filterId]);
            // When no other switch is ON set the vendor's consent
            if (!otherSwitchesOn) vendorConsent[vendor.id] = switchStates[filter.id];
        });

        setVendorConsent(vendorConsent);
        setAllVendorConsent(switchStates[filter.id]);
    }

    const specialFeaturesButton = (config) => {
        return (
            <div className="special-feature">
                <div className="special-feature-label">
                    {config.name}
                </div>
                <div className="opt-in-switch">
                    <Switch isChecked={!!(props.configuration.specialFeatureOptins?.[config.id])}
                            changeHandler={specialFeatureSwitchOnChangeHandler.bind(this, config.id)}
                            color={SwitchColor.BLUE} dataTags={{'data-specialfeature-id': config.id}}/>
                </div>
            </div>
        )
    }

    const purposesButton = (config) => {
        return (
            <div className="purpose">
                <div className="purpose-label">
                    {config.name}
                </div>
                <div className="purpose-switch">
                    <Switch isChecked={!!(props.configuration.purposeConsent?.[config.id])}
                            changeHandler={purposeConsentSwitchOnChangeHandler.bind(this, config.id, config.filterName)}
                            color={SwitchColor.GREEN} dataTags={{'data-purposeconsent-id': config.id}}/>
                    <Switch isChecked={!!(props.configuration.purposeLegitimateInterest?.[config.id])}
                            changeHandler={purposeLegitimateInterestSwitchOnChangeHandler.bind(this, config.id, config.filterName)}
                            color={SwitchColor.ORANGE} dataTags={{'data-purposelegitimateinterest-id': config.id}}/>
                </div>
            </div>
        )
    }

    const renderFilterButtons = (filterName, callback) => {
        return (
            <ul className="filter-buttons">
                {props.currentLanguage.vendorList[filterName].map(object => {
                    let isActive = props.currentFilter?.filterName === filterName && props.currentFilter.value.id === object.id;
                    return (
                        <li className={`filter-button${isActive ? ' active' : ''}`}
                            onClick={() => defaultSwitchOnClickHandler({filterName, object})}
                            key={`${filterName}_${object.id}`}>
                            {typeof callback === 'function' ? callback({
                                id: object.id,
                                name: object.name,
                                filterName,
                                object
                            }) : object.name}
                        </li>
                    );
                })}
            </ul>
        );
    };

    return (
        <div id="filters">
            <h2>{props.currentLanguage.text.labels.purposes}</h2>
            {renderFilterButtons('purposes', purposesButton)}

            <h2>{props.currentLanguage.text.labels.specialPurposes}</h2>
            {renderFilterButtons('specialPurposes')}

            <h2>{props.currentLanguage.text.labels.features}</h2>
            {renderFilterButtons('features')}

            <h2>
                {props.currentLanguage.text.labels.specialFeatures}
                <span className="opt-in-text">{props.currentLanguage.text.labels.optIn}</span>
            </h2>
            {renderFilterButtons('specialFeatures', specialFeaturesButton)}
        </div>
    );

};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {
    setFilter,
    setScreen,
    setSpecialFeatureConsent,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setConsent,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
})(Filter);
